import { render } from "./PhoneNumberEligibilityState.vue?vue&type=template&id=e9c54314&ts=true"
import script from "./PhoneNumberEligibilityState.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneNumberEligibilityState.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/whatsapp-meta/components/PhoneNumberEligibilityState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9c54314"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9c54314', __exports__)) {
    api.reload('e9c54314', __exports__)
  }
  
  module.hot.accept("./PhoneNumberEligibilityState.vue?vue&type=template&id=e9c54314&ts=true", () => {
    api.rerender('e9c54314', render)
  })

}


export default __exports__